const ProfileHero = ({ name, splashImage, genreMain, genreSubs }) => {
  const content = (
    <div className="absolute bottom-0 left-0 right-0 z-10 pb-10 px-6 sm:px-12 flex flex-col gap-3 animate-fade-in">
      <h1 className="font-extrabold text-5xl sm:text-7xl text-white drop-shadow-md tracking-tight">
        {name}
      </h1>
      
      {(genreMain || (genreSubs && genreSubs.length > 0)) && (
        <div className="flex flex-wrap gap-2 mt-1">
          {genreMain && (
            <span className="bg-neutral-900/75 text-stone-300 text-[11px] font-bold uppercase px-3.5 py-1.5 rounded-full border border-stone-800/80 tracking-wider">
              {genreMain}
            </span>
          )}
          {genreSubs && genreSubs.map((tag, index) => (
            <span key={index} className="bg-neutral-900/75 text-stone-300 text-[11px] font-bold uppercase px-3.5 py-1.5 rounded-full border border-stone-800/80 tracking-wider">
              {tag.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <>
      {splashImage ? (
        <div className="relative w-full h-[450px] sm:h-[600px] rounded-b-4xl overflow-hidden shadow-2xl">
          <img
            className="object-cover w-full h-full"
            src={splashImage}
            alt={`${name}´s splash header image`}
          />
          {/* Gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-base-100 via-base-100/40 to-transparent" />
          {content}
        </div>
      ) : (
        <div className="relative w-full h-[280px] rounded-b-4xl bg-gradient-to-br from-neutral-900 to-base-200 overflow-hidden border-b border-base-content/5">
          {content}
        </div>
      )}
    </>
  );
};

export default ProfileHero;
